"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkToIdentityProviderProfile = void 0;
function getLinkToIdentityProviderProfile(baseUrl = '/platform') {
    return `${baseUrl}/api/v1/user/redirect-to-identity-provider-profile`;
}
exports.getLinkToIdentityProviderProfile = getLinkToIdentityProviderProfile;
